import { StateParams } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
import {
  ContractService,
  vsServiceName as ContractServiceName,
} from "../../shared/ContractService";
import {
  vsServiceName as RecordGridViewServiceName,
  GridConfiguration,
  RecordGridViewService,
} from "../../../records/views/recordGridView";
import { vsObjectName as contractInstanceObjectName } from "../../shared/configs/contractInstance";

const gridId = Symbol("main.contract.instances");
export class ContractInstanceComponentController implements IOnInit {
  static $inject = [
    "$stateParams",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    ContractServiceName,
    RecordGridViewServiceName,
  ];
  readonly gridConfiguration!: GridConfiguration;
  gridDataSource!: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly defaultQuery: IQuery = {
    Include: "ContractNumbers",
  };
  columns!: ColDef[];

  constructor(
    public readonly $stateParams: StateParams,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly contractService: ContractService,
    private readonly recordGridViewService: RecordGridViewService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
  }

  $onInit(): void {
    this.gridDataSource = this.gridConfiguration.gridDataSource!;
    this.columns = [
      this.columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          "main.contract.type.info.redirect({ type: data.ContractInstanceType, contractInstanceId: data.ContractInstanceId})",
        requiresPermission: "contractView",
      }),
      this.columnDefinitionService.getLinkColDef({
        colId: "edit",
        headerName: "edit",
        iconClass: "fa fa-pencil text-primary",
        stateExpression:
          "main.contract.type.info.edit({ type: data.ContractInstanceType, contractInstanceId: data.ContractInstanceId })",
      }),
      ...(this.gridConfiguration.columns ?? []),
    ];
  }

  getContractTypes() {
    return this.contractService.getContractTypes();
  }
}
